import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Catalogs } from './catalog.model';
import { environment } from './../../environments/environment';

@Injectable()
export class CatalogService {

  constructor(private httpClient: HttpClient) {}

  items(query: any): Observable<Catalogs> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<Catalogs>(environment.api + '/catalogs', { params: params });
  }

}

